<h2 mat-dialog-title>
  {{
    'CUSTOMIZE_SALES_ORDERS_CONFIG.EMAIL_OPTIONS_SETTINGS.PREVIEW_EMAIL'
      | translate
  }}
</h2>
<mat-dialog-content class="email-viewer-wrapper">
  <glxy-email-viewer [html]="renderedTemplate$ | async"></glxy-email-viewer>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button matDialogClose color="primary">
    {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
